import { idTypesConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addIdType = (state = initialState, action) => {
  switch (action.type) {
    case idTypesConstants.ADD_IDTYPE_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case idTypesConstants.ADD_IDTYPE_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case idTypesConstants.ADD_IDTYPE_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case idTypesConstants.ADD_IDTYPE_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
